import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PhotoUploaderModule } from '@classifieds-sell/trademe-core-ui';
import { TgBoxes2Module, TgGridModule, TgRackModule } from '@trademe/tangram';
import { SummaryAgentContactDetailComponent } from './summary-agent-contact-detail.component';

@NgModule({
    imports: [
        CommonModule,
        TgRackModule,
        TgGridModule,
        TgBoxes2Module,
        RouterModule,
        PhotoUploaderModule],
    declarations: [SummaryAgentContactDetailComponent],
    exports: [SummaryAgentContactDetailComponent]
})
export class SummaryAgentContactDetailModule {}
